module.exports = __webpack_public_path__ + "static/media/img39.1cc20f38.jpg";